export const FETCH_SESSION = 'session/FETCH_SESSION'
export const FETCH_SESSION_COMPLETED = 'session/FETCH_SESSION_COMPLETED'
export const FETCH_SESSION_FAILED = 'session/FETCH_SESSION_FAILED'

export const DESTROY_SESSION = 'session/DESTROY_SESSION'
